import { SET_CATEGORYDETAILLIST } from '../actions';

const categorydetails = (state = [], action) => {
  switch (action.type) {
	case SET_CATEGORYDETAILLIST:
      return [...action.value];  
    default: return state;
  }
}

export default categorydetails;
